/**
 * Game state machine — Plan 08-02 Task 1 (GAME-01).
 *
 * idle → spinning → result → idle 3-phase round lifecycle.
 * Spinning 은 idle 에서만 진입 가능 (result 중 새 라운드 불허).
 *
 * `canTransition(from, to)` 은 순수 함수 — 엔진/UI 양쪽에서 재사용.
 *
 * L4 법적 맥락:
 *   - 상태 전이 로그는 라운드 감사 (seed commit → reveal) 증빙에 사용.
 *   - 누적 랭킹 금지 (DESIGN §21.9) — result 는 단일 라운드 결과만.
 */

export type GameState = 'idle' | 'spinning' | 'result';

/** 허용 전이. 각 state 에서 이동 가능한 next state 목록. */
export const GAME_TRANSITIONS: Record<GameState, readonly GameState[]> = {
  idle: ['spinning'],
  spinning: ['result'],
  result: ['idle'],
};

/** 전이 가능 여부 검사. 리터럴 두 상태 모두 GameState 로 강제. */
export function canTransition(from: GameState, to: GameState): boolean {
  return GAME_TRANSITIONS[from].includes(to);
}
